import React, { useContext, useState } from "react";
import { useGetAllOrganization } from "../../../hooks/useGuidelines";
import "./style.scss";
import DebounceInput from "../../../common/DebounceInput";
import SearchIcon from "../../../assets/CreateCategory/SeachIcon.svg";
import { GuidelinesSelectedCategoryContext } from "../../../context/guidelinesProvider";

const ClientsList = ({ setShowClients }) => {
  const [clientList, setClientList] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [search, setSearch] = useState("");

  const {
    guide_selectedClientId,
    guide_setSelectedClientId,
    guide_setSelectedClientName,
    guide_selectedClientName,
    guide_setSelectedMarketPlaceId,
    guide_setSelectedCategoryId,
    guide_setSelectedSubCategoryId,
  } = useContext(GuidelinesSelectedCategoryContext);
  const onSuccessGetAllClient = (data) => {
    const filteredClients = data?.data?.data.filter((client) => client?.name);

    const defaultClient = {
      _id: null,
      name: "Default",
      users: [{ user: { email: { emailId: "default@example.com" } } }],
    };

    setClientList([defaultClient, ...filteredClients]);
  };

  const onErrorGetAllClient = (err) => {
    console.log(err.message);
  };

  const { data: getAllClients, refetch: refetchClientList } =
    useGetAllOrganization(
      "getAllClients",
      pageNum,
      pageSize,
      onSuccessGetAllClient,
      onErrorGetAllClient
    );

  const handleSelectClient = (id) => {
    guide_setSelectedClientId(id);
    setShowClients(false);
  };

  return (
    <div className="clients_wrapper">
      <div className="client_list">
        <div className="search_wrapper_list">
          <div className="search_list">
            <DebounceInput
              searchName={search}
              setSearchName={setSearch}
              placeholder={"Search"}
              allowClear={true}
              showSearch={true}
            />
            <div className="searchIcon_wrapper">
              <img src={SearchIcon} alt="searchIcon" />
            </div>
          </div>
        </div>
        <div className="client_table">
          <table width="100%" border="1">
            <thead>
              <tr>
                <th className="table_head">Name</th>
                <th className="table_head">Email Id</th>
              </tr>
            </thead>
            <tbody>
              {clientList
                .filter((item) => {
                  if (!search?.trim()) {
                    return true;
                  }
                  const regex = new RegExp(
                    `\\b${search.toLowerCase()}\\b`,
                    "i"
                  );
                  return (
                    item?.name?.toLowerCase().includes(search.toLowerCase()) ||
                    regex.test(item?.name?.toLowerCase())
                  );
                })
                .map((client) => {
                  return (
                    <tr>
                      <td
                        className={`client_description ${
                          guide_selectedClientId === client?._id ? "active" : ""
                        }`}
                        onClick={() => {
                          handleSelectClient(client?._id);
                          guide_setSelectedClientName(client?.name);
                          guide_setSelectedMarketPlaceId("");
                          guide_setSelectedCategoryId("");
                          guide_setSelectedSubCategoryId("");
                        }}
                      >
                        {client?.name}
                      </td>
                      <td>{client?.users[0]?.user?.email?.emailId}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ClientsList;
